import de from "./german";
import en from "./english";

export default {
  de,
  en,
};
